import Gumshoe from 'gumshoejs';

import Component from '../component/component';

import './sidenav.scss';

export default class Sidenav extends Component {
    static initSelector: string = '.sidenav';

    constructor(target: HTMLElement) {
        super(target);

        this.init();
    }

    init(): void {
        const header: HTMLElement = document.querySelector('.header');

        new Gumshoe('.sidenav__link', {
            offset: header ? header.clientHeight : 0,
        });

        this.scrollHandler();
        window.addEventListener('scroll', this.scrollHandler.bind(this));
    }

    scrollHandler(): void {
        const activeItem: HTMLElement = this.element.querySelector('.sidenav__item.active');

        if (activeItem === null) {
            this.element.querySelectorAll('.sidenav__item')[0].classList.add('is-current');
        } else {
            this.element.querySelectorAll('.sidenav__item')[0].classList.remove('is-current');
        }
    }
}
